const debugDiffLimit = 20;

const isObject = function (value) {
  return value !== null && typeof value === "object";
};

const pushDiff = function (diffs, path) {
  if (diffs.length < debugDiffLimit) {
    diffs.push(path === "" ? "$" : path);
  }
};

const diffJson = function (left, right, path, diffs) {
  if (diffs.length >= debugDiffLimit || left === right) {
    return;
  }

  const leftIsArray = Array.isArray(left);
  const rightIsArray = Array.isArray(right);

  if (leftIsArray || rightIsArray) {
    if (!leftIsArray || !rightIsArray) {
      pushDiff(diffs, path);
      return;
    }

    if (left.length !== right.length) {
      pushDiff(diffs, path + ".length");
    }

    const maxLength = Math.max(left.length, right.length);
    for (let index = 0; index < maxLength && diffs.length < debugDiffLimit; index += 1) {
      diffJson(left[index], right[index], `${path}[${index}]`, diffs);
    }
    return;
  }

  if (isObject(left) || isObject(right)) {
    if (!isObject(left) || !isObject(right)) {
      pushDiff(diffs, path);
      return;
    }

    const keys = Array.from(new Set([...Object.keys(left), ...Object.keys(right)])).sort();
    for (const key of keys) {
      if (diffs.length >= debugDiffLimit) {
        break;
      }
      diffJson(left[key], right[key], path === "" ? key : `${path}.${key}`, diffs);
    }
    return;
  }

  pushDiff(diffs, path);
};

export const debugJsonDiffSummary = function (left) {
  return function (right) {
    const diffs = [];
    diffJson(left, right, "", diffs);
    return diffs;
  };
};
